// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H12C13.1 14 14 13.1 14 12V9.33',
  'M12.83 4.28L13.71 3.4C14.15 2.95 14.15 2.23 13.71 1.79C13.27 1.35 12.55 1.35 12.1 1.79L11.22 2.67L6.29 7.6C6.04 7.85 5.87 8.15 5.78 8.49L5.41 9.85C5.37 9.99 5.51 10.13 5.65 10.09L7.01 9.72C7.35 9.63 7.65 9.46 7.9 9.21L12.83 4.28ZM11.22 2.67L11.42 3.1C11.61 3.53 11.97 3.89 12.4 4.08L12.83 4.28',
];
